<template>
  <div class="authority-manage">
    <div class="top-title">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="define-bottom define-bread">
        <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row :gutter="20">
      <el-col :span="4">
        <el-input v-model="title" placeholder="请输入名称" size="small"></el-input>
      </el-col>
      <el-col :span="20">
        <el-button type="primary" @click="search" size="small">查询</el-button>
        <el-button @click="reset" size="small">重置</el-button>
        <el-button type="primary" class="last-col" @click="add" size="small">添加</el-button>
      </el-col>
    </el-row>

    <el-table
        :data="tableData"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        border
        :tree-props="{children: 'children'}"
    >
      <el-table-column prop="label" label="名称" sortable width="180"></el-table-column>
      <el-table-column prop="icon" label="图标" sortable width="180">
        <template slot-scope="scope">
          <i :class="scope.row.icon || ''"></i>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === '0'" size="small">目录</el-tag>
          <el-tag v-else-if="scope.row.type === '1'" size="small" type="success">菜单</el-tag>
          <el-tag v-else-if="scope.row.type === '2'" size="small" type="info">按钮</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="菜单URL"></el-table-column>
      <el-table-column prop="name" label="路由地址"></el-table-column>
      <el-table-column prop="code" label="权限标识"></el-table-column>
      <el-table-column prop="orderNum" label="序号"></el-table-column>
      <el-table-column width="170" align="center" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" @click="editMenu(scope.row)">编辑</el-button>
          <el-button type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--新增权限-->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="45%" :close-on-click-modal="false">
      <el-form
          :rules="addMenuValdate"
          :inline="true"
          :model="addFrom"
          ref="addFrom"
          label-width="80px"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item prop="type" label="权限类型">
              <el-radio-group v-model="addFrom.type">
                <el-radio :label="'0'">目录</el-radio>
                <el-radio :label="'1'">菜单</el-radio>
                <el-radio :label="'2'">按钮</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="parentName" label="上级菜单">
          <el-input readonly @click.native="selectParent" v-model="addFrom.parentName"></el-input>
        </el-form-item>
        <el-form-item prop="label" label="权限名称">
          <el-input v-model="addFrom.label"></el-input>
        </el-form-item>
        <el-form-item prop="icon" v-if="addFrom.type !== '2'" label="菜单图标">
          <el-input v-model="addFrom.icon"></el-input>
        </el-form-item>
        <el-form-item prop="name" v-if="addFrom.type === '1'" label="路由名称">
          <el-input v-model="addFrom.name"></el-input>
        </el-form-item>
        <el-form-item prop="path" v-if="addFrom.type !== '2'" label="路由地址">
          <el-input v-model="addFrom.path"></el-input>
        </el-form-item>
        <el-form-item prop="url" v-if="addFrom.type === '1'" label="组件路径">
          <el-input v-model="addFrom.url"></el-input>
        </el-form-item>
        <el-form-item prop="code" label="权限标识">
          <el-input v-model="addFrom.code"></el-input>
        </el-form-item>
        <el-form-item label="显示序号">
          <el-input-number v-model="addFrom.orderNum"></el-input-number>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addComit">确 定</el-button>
      </span>
    </el-dialog>
    <!--选择上级菜单-->
    <el-dialog title="上级菜单" :visible.sync="parentDialogVisible" width="25%">
      <tree :nodes="nodes" :setting="parentSetting"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="parentDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="parentDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tree from 'vue-giant-tree'

export default {
  data () {
    return {
      title: '',
      addMenuValdate: {
        type: [{required: true, trigger: 'change', message: '请填选择类型'}],
        label: [
          {required: true, trigger: 'change', message: '请填写权限名称'}
        ],
        parentName: [
          {required: true, trigger: 'change', message: '请选择上级菜单'}
        ],
        name: [
          {required: true, trigger: 'change', message: '请填写路由名称'}
        ],
        path: [
          {required: true, trigger: 'change', message: '请填写路由地址'}
        ],
        url: [{required: true, trigger: 'change', message: '请填写组件路径'}],
        code: [{required: true, trigger: 'change', message: '请填写权限标识'}]
      },
      // 0 新增  1 编辑
      editTag: '0',
      nodes: [
        {
          id: 0,
          pid: -1,
          name: '顶级菜单',
          open: true,
          checked: false
        },
        {
          id: 17,
          pid: 0,
          name: '系统管理',
          open: true,
          checked: false
        },
        {
          id: 16,
          pid: 0,
          name: '实例数据管理',
          open: true,
          checked: false
        },
        {
          id: 18,
          pid: 17,
          name: '用户管理',
          open: true,
          checked: false
        },
        {
          id: 23,
          pid: 17,
          name: '角色管理',
          open: true,
          checked: false
        },
        {
          id: 28,
          pid: 17,
          name: '权限管理',
          open: true,
          checked: false
        },
        {
          id: 33,
          pid: 17,
          name: '机构管理',
          open: true,
          checked: false
        },
        {
          id: 34,
          pid: 0,
          name: '商品管理',
          open: true,
          checked: false
        },
        {
          id: 36,
          pid: 34,
          name: '分类管理',
          open: true,
          checked: false
        },
        {
          id: 37,
          pid: 34,
          name: '品牌管理',
          open: true,
          checked: false
        },
        {
          id: 42,
          pid: 0,
          name: '系统工具',
          open: true,
          checked: false
        },
        {
          id: 43,
          pid: 42,
          name: '代码生成',
          open: true,
          checked: false
        },
        {
          id: 77,
          pid: 42,
          name: '接口文档',
          open: true,
          checked: false
        }
      ],
      // 控制上级部门弹框显示
      parentDialogVisible: false,
      // 上级部门树配置
      parentSetting: {
        view: {
          showLine: true,
          showIcon: false,
          fontCss: {'font-size': '12px', color: '#333'}
        },
        // 设置这里会显示复选框
        // check: {
        //   enable: true
        // },
        data: {
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'pid',
            rootPId: '0'
          }
        },
        callback: {
          onClick: this.ztreeParentOnClick
        }
      },
      // 存储表单数据
      addFrom: {
        id: '', // 编辑id
        label: '',
        name: '',
        type: 0,
        parentId: '',
        orderNum: '',
        parentName: '',
        path: '',
        url: '',
        code: '',
        icon: ''
      },
      dialogTitle: '',
      // 控制弹框显示和影藏
      dialogVisible: false,
      // 搜索数据绑定
      searchForm: {
        roleName: ''
      },
      // 表格数据
      tableData: []
    }
  },
  components: {
    tree
  },
  mounted () {
  },
  created () {
    this.getMenuList()
    this.getParenList()
  },
  methods: {
    async handleDelete (row) {
      let _this = this
      _this.$confirm('确定删除吗 ?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let {data: res} = await _this.$http.post('/api/permission/deleteById', {id: row.id})
        if (res.code === 200) {
          // 刷新表格数据
          await _this.getMenuList()
        }
        _this.$message({
          message: res.msg,
          type: 'success'
        })
      })
    },
    // 编辑权限点击事件
    editMenu (row) {
      // 设置编辑标志为1
      this.editTag = '1'
      this.boxTitle = '编辑权限'
      this.dialogVisible = true
      this.resetForm('addMenu')
      // 回显编辑的数据
      this.getPermissionById(row.id)
    },
    async getPermissionById (id) {
      let {data: res} = await this.$http.post('/api/permission/getPermissionById', {id})
      if (res.code === 200) {
        this.addFrom.id = res.data.id
        this.addFrom.code = res.data.code
        this.addFrom.icon = res.data.icon
        this.addFrom.label = res.data.label
        this.addFrom.name = res.data.name
        this.addFrom.orderNum = res.data.orderNum
        this.addFrom.parentId = res.data.parentId
        this.addFrom.parentName = res.data.parentName
        this.addFrom.path = res.data.path
        this.addFrom.type = res.data.type
        this.addFrom.url = res.data.url
      }
    },
    // 新增或编辑提交
    addComit () {
      let _this = this
      _this.$refs.addFrom.validate(async valid => {
        if (valid) {
          let parm = _this.addFrom
          let url = ''
          if (_this.editTag === '0') {
            url = '/api/permission/addPermission'
          } else {
            url = '/api/permission/editSave'
          }
          let {data: res} = await _this.$http.post(url, parm)
          if (res.code === 200) {
            _this.dialogVisible = false
            await _this.getMenuList()
            await _this.getParenList()
            _this.$message({
              message: res.msg,
              type: 'success'
            })
          } else {
            _this.$message({
              message: res.msg,
              type: 'error'
            })
          }
        }
      })
    },
    // 获取表格数据
    async getMenuList () {
      let {data: res} = await this.$http.post('/api/permission/getExhibitionMenuList', {label: this.title})
      console.log(res)
      if (res.code === 200) {
        this.tableData = res.data
      }
    },
    async getParenList () {
      let {data: res} = await this.$http.post('/api/permission/getParenList')
      console.log(res)
      if (res.code === 200) {
        this.nodes = res.data
      }
    },
    // 选择上级菜单
    selectParent () {
      this.parentDialogVisible = true
    },
    // 新增权限点击事件
    add () {
      // 标志新增
      this.editTag = '0'
      this.dialogTitle = '新增权限'
      this.dialogVisible = true
      // 清空表单数据
      this.resetForm('addFrom')
    },
    // 重置
    reset () {
      this.title = ''
      this.getMenuList()
    },
    // 搜索
    search () {
      this.getMenuList()
    },
    // 解决重置表单时报 'resetFields' of undefined的错
    resetForm (formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields()
      }
    },
    // 上级部门树点击事件
    ztreeParentOnClick (evt, treeId, treeNode) {
      this.addFrom.parentName = treeNode.name
      this.addFrom.parentId = treeNode.id
    }
  }
}
</script>

<style lang="less">
.authority-manage {
  .el-dialog__wrapper /deep/ .el-dialog__body {
    padding-top: 10px !important;
    padding-bottom: 5px !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/authority/authority_manage.vue